<template lang="pug">
#v-copyright.copyright.container
  address.copyright__content
    | Copyright © 2018 流線傳媒有限公司 All rights reserved.
    |
    br(v-if='$store.state.mobile')
    a(href='https://buzzorange.com/techorange/', target='_blank') TechOrange科技報橘
    | ｜
    a(href='https://buzzorange.com/', target='_blank') BuzzOrange報橘
    | ｜
    a(href='https://buzzorange.com/vidaorange/', target='_blank') VidaOrange生活報橘
</template>

<script>
export default {
  name: 'Copyright',
}
</script>

<style lang="sass" scoped>
.copyright
  padding-bottom: 41px
  padding-top: 49px
  &__content
    +font(14px, #5A5A5A)
    text-align: center

@media (max-width: 991px)
  .copyright
    padding-bottom: 20px
    padding-top: 30px
    &__content
      +font(12px, null, 18px)
      transform-origin: .5em .5em
      transform: scale(.75)
      width: 130%
</style>
